import React, { useEffect, useState } from 'react';
import './index.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TableNavButton } from 'common/styles/TableNavButton';
import { SelectChangeEvent, useTheme } from '@mui/material';
import Input from 'common/components/Input';
import { ReactComponent as CameraIcon } from './images/camera.svg';
import SelectEl from 'common/components/Select';
import TextArea from 'common/components/TextArea';
import Button from 'common/components/Button';
import { useAuth } from 'common/context/AuthContext';
import sendFetch from 'common/utils/fetch';
import { genderList } from 'common/data/genderList';
import { paymentList } from 'common/data/paymentList';
import ClientFormProps, { ClientFormErrorProps } from 'common/types/ClientFormProps';
import ClientResponseProps from 'common/types/UserResponseProps';
//import { ReactComponent as BackgroundImg } from './images/background.svg'; 
//import UserDataProps from 'common/types/UserDataProps';

const cleanForm = {
  lastName: '',
  firstName: '',
  patronymic: '',
  gender: 0,
  birthDate: '',
  additionalInformation: '',
  country: '',
  city: '',
  street: '',
  address: '',
  appartment: '',
  phoneNumber: '',
  email: '',
  paymentType: 0,
  card: '',
  companyName: '',
  companyNumber: '',
  postalCode: '',
};

const cleanFormErrors: ClientFormErrorProps = {
  lastName: false,
  firstName: false,
  patronymic: false,
  gender: false,
  birthDate: false,
  additionalInformation: false,
  country: false,
  city: false,
  street: false,
  address: false,
  appartment: false,
  phoneNumber: false,
  email: false,
  paymentType: false,
  card: false,
  companyName: false,
  companyNumber: false,
  postalCode: false,
};

// const names = ['Андрій', 'Богдан', 'Віктор', 'Григорій', 'Дмитро', 'Євген', 'Жанна', 'Зінаїда', 'Іван', 'Катерина', 'Леся', 'Марія', 'Наталія', 'Олександр', 'Петро', 'Роман', 'Сергій', 'Тетяна', 'Уляна', 'Федір', 'Христина', 'Цезар', 'Чеслав', 'Шарлотта', 'Щастя', 'Юлія', 'Ярослав'];

// const getRandomName = () => {
//   return names[Math.floor(Math.random() * names.length)];
// };

// const mockUser = {
//   firstName: getRandomName(),
//   lastName: getRandomName(),
//   patronymic: getRandomName(),
//   phoneNumber: '+380' + Math.floor(Math.random() * 900000000 + 100000000),
//   gender: Math.floor(Math.random() * 2),
//   birthDate: '1990-01-01',
//   additionalInformation: 'Some additional information',
//   country: 'Ukraine',
//   city: 'Kyiv',
//   street: 'Some street',
//   address: 'Some address',
//   appartment: 'Some appartment',
//   email: 'test@test.com',
//   paymentType: Math.floor(Math.random() * 2),
//   card: '1234 5678 9012 3456',
//   postalCode: '12345',
// };

// const generateMockUser = () => {
//   const coolUser = { ...mockUser };
//   coolUser.firstName = getRandomName();
//   coolUser.lastName = getRandomName();
//   coolUser.patronymic = getRandomName();
//   coolUser.phoneNumber = '+380' + Math.floor(Math.random() * 900000000 + 100000000);

//   return coolUser;
// };


export default function AddUserPage({ order, setPageType, setClient }: { order?: boolean, setPageType?: React.Dispatch<React.SetStateAction<'order' | 'create-client'>>, setClient?: React.Dispatch<React.SetStateAction<ClientResponseProps>> }) {
  const { companyId } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [form, setForm] = useState<ClientFormProps>(cleanForm);
  const [formErrors, setFormErrors] = useState<ClientFormErrorProps>(cleanFormErrors);
  const theme = useTheme();
  const type: string = searchParams.get('type') || '';

  const handleTypeChange = (value: string | null) => {
    if (value) {
      searchParams.set('type', value);
    } else {
      searchParams.delete('type');
    }
    setSearchParams(searchParams, { replace: true });
  };

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    // check for errors, remove if value is not empty now
    if (formErrors[e.target.name]) {
      if (e.target.value !== '') {
        setFormErrors((prev) => ({ ...prev, [e.target.name]: false }));
      }
    }
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleSelectChange = (e: SelectChangeEvent) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Clear form on type change

  useEffect(() => {
    setForm(cleanForm);
    setFormErrors(cleanFormErrors);
  }, [type]);

  // Handle return button

  const handleReturn = () => {
    console.log('yo ' + order);
    if (order) {
      setPageType('order');
    } else {
      navigate(-1);
    }
  };

  // Handle form submit

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log(form);
    if (form.firstName === '' || form.lastName === '' || form.phoneNumber === '') {
      setFormErrors((prev) => ({
        ...prev,
        firstName: form.firstName === '',
        lastName: form.lastName === '',
        phoneNumber: form.phoneNumber === '',
      }));
    }
    if (type === 'legal entity' && form.companyName === '') {
      setFormErrors((prev) => ({
        ...prev,
        companyName: form.companyName === '',
      }));
    }
    if (type === 'legal entity' && form.companyNumber === '') {
      setFormErrors((prev) => ({
        ...prev,
        companyNumber: form.companyNumber === '',
      }));
    }
    if (type === 'legal entity' && form.postalCode === '') {
      setFormErrors((prev) => ({
        ...prev,
        postalCode: form.postalCode === '',
      }));
    }
    // if any errors return

    if (Object.values(formErrors).some((el) => el)) {
      return;
    }
    const formData = new FormData();
    formData.append('companyId', companyId);
    formData.append('lastName', form.lastName);
    formData.append('firstName', form.firstName);
    formData.append('patronymic', form.patronymic || '');
    formData.append('gender', form.gender?.toString() || '');
    formData.append('birthDate', form.birthDate || '');
    formData.append('additionalInformation', form.additionalInformation || '');
    formData.append('country', form.country || '');
    formData.append('city', form.city || '');
    const address = `${form.street || ''}${'|||' + form.address || ''}${'|||' + form.appartment || ''}`;
    formData.append('address', address || '');
    formData.append('phoneNumber', form.phoneNumber || '');
    formData.append('email', form.email || '');
    formData.append('paymentType', form.paymentType?.toString() || '');
    formData.append('card', form.card || '');
    formData.append('companyName', form.companyName || '');
    formData.append('companyNumber', form.companyNumber || '');
    formData.append('postalCode', form.postalCode || '');
    console.log(formData);

    const response:[number, ClientResponseProps] = await sendFetch('https://api-workspace.astin.net/api/user/create-client', {
      method: 'POST',
      data: formData,
    });
    console.log(response);
    if (response[0] === 200) {
      if (order) {
        setClient(response[1]);
        setForm(cleanForm);
        setPageType('order');
      } else {
        setForm(cleanForm);
        navigate(-1);
      }
    }
  };



  return (
        <section className='add-user-section'>
            <div className='add-user-background'>

            </div>
            <h2 className='new-h2 add-user-title'>Створення картки клієнта</h2>
            <div className='add-user-nav-line'>
                <span className='new-h3'>Оберіть тип особи:</span>
                <div className='add-user-nav-wrapper'>
                    <TableNavButton onClick={() => { handleTypeChange('individual person'); }} className={type !== 'legal entity' && 'active'}>Фізична особа</TableNavButton>
                    <TableNavButton onClick={() => { handleTypeChange('legal entity'); }} className={type === 'legal entity' && 'active'}>Юридична особа</TableNavButton>
                </div>
            </div>
            <form onSubmit={handleFormSubmit} className='add-user-form-wrapper'>
                <div style={{ borderColor: theme.colors.gray, backgroundColor: theme.colors.backgroundColor }} className='add-user-form'>
                    <h3 className='new-h3 add-user-title'>{type !== 'legal entity' ? 'Реєстрація фізичної особи' : 'Реєстрація юридичної особи'}</h3>
                    <div className='add-user-photo-lines'>
                        <div className='add-user-photo-wrapper'>
                            <CameraIcon height={64} width={64} />
                        </div>
                        <div className='add-user-photo-line-wrapper'>
                            {type !== 'legal entity' ?
                              (<>
                                    <div className='add-user-line-wrapper'>
                                        <p className='new-p add-user-line-label'>Прізвище</p>
                                        <Input
                                            placeholder='Введіть прізвище'
                                            className='add-user-small-input'
                                            name='lastName'
                                            value={form.lastName}
                                            onChange={handleValueChange}
                                            props={{ autoComplete: 'off' }}
                                            error={formErrors.lastName}
                                        />
                                    </div>
                                    <div className='add-user-line-wrapper'>
                                        <p className='new-p add-user-line-label'>Ім’я</p>
                                        <Input
                                            placeholder='Введіть ім’я'
                                            className='add-user-small-input'
                                            name='firstName'
                                            value={form.firstName}
                                            onChange={handleValueChange}
                                            props={{ autoComplete: 'off' }}
                                            error={formErrors.firstName}
                                        />
                                    </div>
                                    <div className='add-user-line-wrapper'>
                                        <p className='new-p add-user-line-label'>Побатькові</p>
                                        <Input
                                            placeholder='Введіть побатькові'
                                            className='add-user-small-input'
                                            name='patronymic'
                                            value={form.patronymic}
                                            onChange={handleValueChange}
                                            props={{ autoComplete: 'off' }}
                                            error={formErrors.patronymic}
                                        />
                                    </div>
                                </>) : (<>
                                    <div className='add-user-line-wrapper'>
                                        <p className='new-p add-user-line-label'>Найменування</p>
                                        <Input
                                            placeholder='Введіть назву'
                                            className='add-user-small-input'
                                            name='companyName'
                                            value={form.companyName}
                                            onChange={handleValueChange}
                                            props={{ autoComplete: 'off' }}
                                            error={formErrors.companyName}
                                        />
                                    </div>
                                    <div className='add-user-line-wrapper'>
                                        <p className='new-p add-user-line-label'>Прізвище</p>
                                        <Input
                                            placeholder='Введіть прізвище представника'
                                            className='add-user-small-input'
                                            name='lastName'
                                            value={form.lastName}
                                            onChange={handleValueChange}
                                            props={{ autoComplete: 'off' }}
                                            error={formErrors.lastName}
                                        />
                                    </div>
                                    <div className='add-user-line-wrapper'>
                                        <p className='new-p add-user-line-label'>Ім’я</p>
                                        <Input
                                            placeholder='Введіть ім’я представника'
                                            className='add-user-small-input'
                                            name='firstName'
                                            value={form.firstName}
                                            onChange={handleValueChange}
                                            props={{ autoComplete: 'off' }}
                                            error={formErrors.firstName}
                                        />
                                    </div>
                                </>)}
                        </div>
                    </div>
                    <div className='add-user-lines'>
                        {type !== 'legal entity' && <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>Стать</p>
                            <div className='add-user-input add-user-select-wrapper'>
                                <SelectEl error={formErrors.gender} onChange={handleSelectChange} name='gender' placeholder='Оберіть стать' value={form.gender} data={genderList} />
                            </div>
                        </div>}
                        <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>{type !== 'legal entity' ? 'Дата народження' : 'Дата заснування'}</p>
                            <Input
                                placeholder='Введіть дату народження'
                                className='add-user-input'
                                name='birthDate'
                                value={form.birthDate}
                                onChange={handleValueChange}
                                props={{ autoComplete: 'off', type: 'date' }}
                                error={formErrors.birthDate}
                            />
                        </div>
                        <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>Опис</p>
                            <TextArea
                                placeholder='Опишіть важливу інформацію'
                                className='add-user-input'
                                name='additionalInformation'
                                value={form.additionalInformation}
                                onChange={handleValueChange}
                                props={{ autoComplete: 'off', maxLength: 150 }}
                                error={formErrors.additionalInformation}
                            />
                        </div>
                        <span className='small-text add-user-textarea-count'>{form.additionalInformation.length} / 150</span>
                        {type === 'legal entity' &&

                            <div className='add-user-line-wrapper'>
                                <p className='new-p add-user-line-label'>Індекс</p>
                                <Input
                                    placeholder='Введіть індекс'
                                    className='add-user-input'
                                    name='postalCode'
                                    value={form.postalCode}
                                    onChange={handleValueChange}
                                    props={{ autoComplete: 'off' }}
                                    error={formErrors.postalCode}
                                />
                            </div>

                        }
                        <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>Країна</p>
                            <Input
                                placeholder='Введіть країну'
                                className='add-user-input'
                                name='country'
                                value={form.country}
                                onChange={handleValueChange}
                                props={{ autoComplete: 'off' }}
                                error={formErrors.country}
                            />
                        </div>
                        <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>Місто</p>
                            <Input
                                placeholder='Введіть місто'
                                className='add-user-input'
                                name='city'
                                value={form.city}
                                onChange={handleValueChange}
                                props={{ autoComplete: 'off' }}
                                error={formErrors.city}
                            />
                        </div>
                        <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>Вулиця</p>
                            <Input
                                placeholder='Введіть вулицю'
                                className='add-user-input'
                                name='street'
                                value={form.street}
                                onChange={handleValueChange}
                                props={{ autoComplete: 'off' }}
                                error={formErrors.street}
                            />
                        </div>
                        <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>{type !== 'legal entity' ? 'Будинок' : 'Офіс'}</p>
                            <Input
                                placeholder={type !== 'legal entity' ? 'Введіть номер будинку' : 'Введіть номер офісу'}
                                className='add-user-input'
                                name='address'
                                value={form.address}
                                onChange={handleValueChange}
                                props={{ autoComplete: 'off' }}
                                error={formErrors.address}
                            />
                        </div>
                        <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>Квартира</p>
                            <Input
                                placeholder='Введіть номер квартири'
                                className='add-user-input'
                                name='appartment'
                                value={form.appartment}
                                onChange={handleValueChange}
                                props={{ autoComplete: 'off' }}
                                error={formErrors.appartment}
                            />
                        </div>
                        {type === 'legal entity' &&
                            <div className='add-user-line-wrapper'>
                                <p className='new-p add-user-line-label'>Номер</p>
                                <Input
                                    placeholder='Введіть юридичний номер'
                                    className='add-user-input'
                                    name='companyNumber'
                                    value={form.companyNumber}
                                    onChange={handleValueChange}
                                    props={{ autoComplete: 'off' }}
                                    error={formErrors.companyNumber}
                                />
                            </div>
                        }
                        <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>Номер телефона</p>
                            <Input
                                placeholder='Введіть номер телефона'
                                className='add-user-input'
                                name='phoneNumber'
                                value={form.phoneNumber}
                                onChange={handleValueChange}
                                props={{ autoComplete: 'off' }}
                                error={formErrors.phoneNumber}
                            />
                        </div>
                        <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>Ел. пошта</p>
                            <Input
                                placeholder='Введіть ел. пошту'
                                className='add-user-input'
                                name='email'
                                value={form.email}
                                onChange={handleValueChange}
                                props={{ autoComplete: 'off' }}
                                error={formErrors.email}
                            />
                        </div>
                        <div className='add-user-line-wrapper'>
                            <p className='new-p add-user-line-label'>Спосіб оплати</p>
                            <div className='add-user-input add-user-select-wrapper'>
                                <SelectEl error={formErrors.paymentType} onChange={handleSelectChange} name='paymentType' placeholder='Оберіть спосіб оплати' value={form.paymentType} data={paymentList} />
                            </div>
                        </div>
                        {form.paymentType === 3 &&
                            <div className='add-user-line-wrapper'>
                                <p className='new-p add-user-line-label'>Номер картки</p>
                                <Input
                                    placeholder='Введіть номер картки'
                                    className='add-user-input'
                                    name='card'
                                    value={form.card}
                                    onChange={handleValueChange}
                                    props={{ autoComplete: 'off' }}
                                    error={formErrors.card}
                                />
                            </div>
                        }

                    </div>
                </div>
                <div className='add-user-button-wrapper'>
                    {!order ? <Button type='button' disabled label='У чернетку' /> : <div></div>}
                    <div className='add-user-button-wrapper'>
                        <Button type='button' onClick={handleReturn} label='Повернутись' />
                        <Button type='submit' primary label={order ? 'Додати до бази' : 'Зареєструвати'} />
                    </div>
                </div>
            </form>
        </section>
  );
}